import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import SemanticContainer from 'semantic-ui-react/dist/es/elements/Container/Container';
import { Ref } from '@fluentui/react-component-ref/dist/es/Ref';

import './Container.scss';

export const Container = ({
  children,
  innerRef = null,
  style = {},
  staticWrapper = false,
  className = '',
  testId = 'op-container',
  ...props
}) => {
  const containerStyle = useMemo(
    () => ({
      ...style,
    }),
    [style],
  );

  const content = (
    <SemanticContainer
      data-testid={testId}
      className={`op-content-container op-container${
        className ? ` ${className}` : ''
      }`}
      style={containerStyle}
      fluid
      {...props}
    >
      <div
        className={`op-content-container op-container__wrapper${
          staticWrapper ? '' : ' op-position-relative'
        }`}
      >
        {children}
      </div>
    </SemanticContainer>
  );

  return innerRef ? <Ref innerRef={innerRef}>{content}</Ref> : content;
};

Container.propTypes = {
  children: PropTypes.any.isRequired,
  innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  style: PropTypes.object,
  className: PropTypes.string,
  staticWrapper: PropTypes.bool,
  testId: PropTypes.string,
};
